import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useEventsStore = defineStore('eventsStore', () => {
  const events = ref([])
  const selectedDate = ref(new Date())
  const isLoading = ref(false)

  return { events, selectedDate, isLoading }
})
